import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, from, interval } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/auth/services/auth.service';
import { take, switchMap, tap } from 'rxjs/operators';
import firebase from 'firebase/app';
import { Router } from '@angular/router';
import { ToasterType } from '../../alert-system/core/enums/toaster-type.enum';
import { AlertSystemService } from '../../alert-system/alert-system.service';

export const InterceptorIgnoreHeader = 'X-Ignore-Interceptor';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isTokenToasterShowing = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private alertSystemService: AlertSystemService
  ) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Allow to ignore headers, in case of using 3d parties
    if (req.headers.has(InterceptorIgnoreHeader)) {
      const newHeaders = req.headers.delete(InterceptorIgnoreHeader);

      return next.handle(req.clone({ headers: newHeaders }));
    }
    const ingnoreContentType = 'X-Ignore-ContentType';

    return this.authService.firebaseUser$.pipe(
      take(1),
      switchMap((firebseUser: firebase.User) => {
        return from(firebseUser.getIdToken());
      }),
      switchMap((tokenId: string) => {
        let headers = new HttpHeaders().set('authorization', 'Bearer ' + tokenId);
        if (!req.headers.has(ingnoreContentType)) {
          headers = headers.append('content-type', 'application/json');
        }
        const copiedReq = req.clone({ headers });

        return next.handle(copiedReq).pipe(
          tap(
            () => {},
            (httpError: HttpErrorResponse) => {
              if (httpError.error?.sourceTag === 'ERR_007' && !this.isTokenToasterShowing) {
                this.isTokenToasterShowing = true;
                this.showTokenToaster(httpError);
              }
            }
          )
        );
      })
    );
  }

  private showTokenToaster(httpError: HttpErrorResponse) {
    this.alertSystemService.showToaster({
      title: httpError.error.errors[0].name,
      content: 'Please login again',
      type: ToasterType.Error,
    });

    this.authService.logout();
    this.router.navigate(['auth']);

    interval(5000)
      .pipe(take(1))
      .subscribe(() => {
        this.isTokenToasterShowing = false;
      });
  }
}
